module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.fa277232.woff";